export default __webpack_public_path__ + "static/media/lacrosse-player-image.6bdc3161.jpg";